import type { createFavoritePageActions } from '../domain/actions'
import * as React from 'react'

interface FavoritePageDependencies {
  actions: ReturnType<typeof createFavoritePageActions>
}

const FavoritePageDependenciesContext = React.createContext<FavoritePageDependencies | null>(null)

export function FavoritePageDependenciesProvider({
  children,
  dependencies,
}: React.PropsWithChildren<{ dependencies: FavoritePageDependencies }>) {
  return (
    <FavoritePageDependenciesContext value={dependencies}>
      {children}
    </FavoritePageDependenciesContext>
  )
}

export function useFavoritePageActions() {
  const dependencies = React.use(FavoritePageDependenciesContext)

  if (!dependencies) {
    throw new Error('FavoritePageDependenciesProvider has not been initialized.')
  }

  return dependencies.actions
}
